import { render, staticRenderFns } from "./UserNavDropdown.vue?vue&type=template&id=291fb904&scoped=true"
import script from "./UserNavDropdown.vue?vue&type=script&lang=js"
export * from "./UserNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserNavDropdown.vue?vue&type=style&index=0&id=291fb904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291fb904",
  null
  
)

export default component.exports